// extracted by mini-css-extract-plugin
module.exports = {"componentHolder":"CustomerInformation_componentHolder__1MEtO","InputHolder":"CustomerInformation_InputHolder__2bXpY"};